import { render, staticRenderFns } from "./EmptyLayout.layout.vue?vue&type=template&id=209efaac&scoped=true&"
import script from "./EmptyLayout.layout.vue?vue&type=script&lang=ts&"
export * from "./EmptyLayout.layout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209efaac",
  null
  
)

export default component.exports